module.exports = __webpack_public_path__ + "img/pres_4.93db4157.jpg";